module.exports = __webpack_public_path__ + "static/gps-c35e0d68a7557a82c4ccb28bd6da6893.png";